import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ProgressService } from '@core/services/progress.service';

/** Set to true on requests that should not trigger the global loading overlay. */
export const SKIP_PROGRESS = new HttpContextToken<boolean>(() => false);

export const progressInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_PROGRESS)) {
    return next(req);
  }

  const progress = inject(ProgressService);
  progress.increment();

  return next(req).pipe(
    finalize(() => progress.decrement()),
  );
};
